import { render, staticRenderFns } from "./reservation-table-standalone.vue?vue&type=template&id=edcbe04c&scoped=true&"
import script from "./reservation-table-standalone.vue?vue&type=script&lang=js&"
export * from "./reservation-table-standalone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcbe04c",
  null
  
)

export default component.exports